import { UNIT } from 'actionTypes';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';
import thunkFactory from 'utils/redux/baseEntitiesFactory/thunk';

// ACTIONS
const rawActions = actionsFactory(UNIT);
const actions = { ...rawActions, ...thunkFactory(UNIT, '/units/') };
export { actions };

// REDUCER
const initialState = {
  ids: [],
  models: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};

export default reducerFactory(UNIT, initialState);

// SAGAS
const sagas = sagasFactory(UNIT, '/units/');
export { sagas };
